import {useTranslation} from '@/translations/i18n.tsx'
import {Button} from '@components/ui/button'
import {ArrowRightIcon, ArrowUpRightIcon, ChevronDownIcon} from '@components/ui/icon'
import {Dispatch, SetStateAction} from 'react'
import {Assignment} from 'src/features/assignment/types'
import {errorHandler} from '@utilities/helpers.ts'
import {isBefore} from 'date-fns'
import {useVideoUpload} from '@features/video-upload/store.ts'
import {
    DropdownMenu,
    DropdownMenuContent,
    DropdownMenuGroup,
    DropdownMenuItem,
    DropdownMenuSeparator,
    DropdownMenuTrigger
} from '@components/ui/dropdown-menu'

export const AssignmentUploadVideoDropdown = ({
    assignment,
    setIsLoading,
    setClickedDarylButton
}: {
    assignment: Assignment
    setClickedDarylButton: Dispatch<SetStateAction<boolean>>
    setIsLoading: Dispatch<SetStateAction<boolean>>
}) => {
    const {t} = useTranslation()
    const setIsVideoUploadModalOpen = useVideoUpload(store => store.setIsOpen)

    const onUploadAssets = () => {
        try {
            setIsLoading(true)
            window.open(
                `https://airbnb.orangelogic.com/asset-management/${assignment.task.daryl_directory_id}?Flat=y&WS=AssetManagement`,
                '_blank',
                'noopener,noreferrer'
            )

            setClickedDarylButton(true)
        } catch (e) {
            errorHandler(e)
        } finally {
            setIsLoading(false)
        }
    }

    return (
        <DropdownMenu>
            <DropdownMenuTrigger
                render={
                    <Button variant="secondary">
                        {t('assignment:descriptions:upload_assets')}
                        <ChevronDownIcon />
                    </Button>
                }
                nativeButton={true}
            />

            <DropdownMenuContent
                align="start"
                sideOffset={8}
                className="bg-white border border-neutral-200 rounded-lg shadow-lg overflow-hidden w-full md:w-60"
            >
                <DropdownMenuGroup className="py-1 px-1.5">
                    <DropdownMenuItem
                        className="flex justify-between text-sm py-2.5 px-2 font-medium cursor-pointer rounded-lg hover:bg-neutral-50 [&>svg]:fill-neutral-500"
                        onClick={() => setIsVideoUploadModalOpen(false)}
                    >
                        {t('assignment:upload_edited_video')}
                        <ArrowRightIcon />
                    </DropdownMenuItem>

                    <DropdownMenuItem
                        className="flex justify-between text-sm py-2.5 px-2 font-medium cursor-pointer rounded-lg hover:bg-neutral-50 [&>svg]:fill-neutral-500"
                        onClick={onUploadAssets}
                    >
                        {t('single_shooting:open_daryl')}
                        <ArrowUpRightIcon />
                    </DropdownMenuItem>
                </DropdownMenuGroup>

                {!!assignment.to_shoot_at && isBefore(new Date(assignment.to_shoot_at), new Date()) && (
                    <>
                        <DropdownMenuSeparator />
                        <DropdownMenuGroup className="py-1 px-1.5">
                            <p className="text-sm text-neutral-600 py-1 px-2">{t('assignment:upon_request')}</p>
                            <DropdownMenuItem
                                className="flex justify-between text-sm py-2.5 px-2 font-medium cursor-pointer rounded-lg hover:bg-neutral-50 [&>svg]:fill-neutral-500"
                                disabled
                                onClick={() => window.open('https://airbnb.com', '_blank', 'noopener,noreferrer')}
                            >
                                {t('assignment:open_ikonic')}
                                <ArrowUpRightIcon />
                            </DropdownMenuItem>
                        </DropdownMenuGroup>
                    </>
                )}
            </DropdownMenuContent>
        </DropdownMenu>
    )
}
